/* ============================================================
   EBM SPIN 360 — « le tour du propriétaire »
   > MODIF FABLE 5 | 2026-07-04 | création (mission V3-CAR, run V3 EXCELLENCE)

   Walkaround drag-to-rotate sur VUES RÉELLES (détourage local, zéro pixel
   généré sur la voiture, fond studio unique partagé par toutes les vues).
   5 stations réelles + 2 vues détail brutes. Honnête par construction :
   ce n'est PAS un faux 360 interpolé — le vrai 360 arrivera par capture
   splat (protocole PROTOCOLE_CAPTURE_SPLAT_DUSTER.md).

   Usage : <div data-spin360 data-base="/assets/img/duster/spin360"></div>
   Auto-mount (MutationObserver) : fonctionne aussi dans des <template>
   clonés après coup (panneaux du garage/pavillon). Zéro dépendance. ~7 Ko.
   ============================================================ */
(function () {
  'use strict';

  var MOBILE_W = 640; // en-dessous : frames mobile/

  function el(tag, cls, parent) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (parent) parent.appendChild(n);
    return n;
  }

  var CSS = [
    '.ebm-spin{position:relative;width:100%;aspect-ratio:16/10;background:#0d0e11;border-radius:14px;',
    'overflow:hidden;user-select:none;-webkit-user-select:none;touch-action:pan-y;cursor:grab;outline:none}',
    '.ebm-spin.dragging{cursor:grabbing}',
    '.ebm-spin img.f{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;',
    'transition:opacity .16s ease;opacity:0;pointer-events:none}',
    '.ebm-spin img.f.on{opacity:1}',
    '.ebm-spin .hud{position:absolute;left:14px;bottom:12px;display:flex;align-items:center;gap:10px;',
    'font:600 11px/1 "Archivo V",Archivo,system-ui,sans-serif;letter-spacing:.14em;text-transform:uppercase;',
    'color:rgba(240,238,234,.78);pointer-events:none}',
    '.ebm-spin .hud .dot{width:6px;height:6px;border-radius:50%;background:#ff5b04}',
    '.ebm-spin .dots{position:absolute;right:14px;bottom:14px;display:flex;gap:6px;pointer-events:none}',
    '.ebm-spin .dots i{width:5px;height:5px;border-radius:50%;background:rgba(240,238,234,.28);transition:background .2s}',
    '.ebm-spin .dots i.on{background:#ff5b04}',
    '.ebm-spin .hint{position:absolute;inset:0;display:flex;align-items:center;justify-content:center;',
    'pointer-events:none;transition:opacity .5s ease}',
    '.ebm-spin .hint span{background:rgba(10,9,8,.55);backdrop-filter:blur(3px);border:1px solid rgba(255,255,255,.14);',
    'border-radius:99px;padding:10px 18px;font:600 12px/1 "Archivo V",Archivo,system-ui,sans-serif;',
    'letter-spacing:.12em;text-transform:uppercase;color:rgba(240,238,234,.9)}',
    '.ebm-spin .hint.off{opacity:0}',
    '.ebm-spin-chips{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}',
    '.ebm-spin-chips button{background:none;border:1px solid rgba(240,238,234,.22);border-radius:99px;',
    'padding:7px 14px;font:600 10.5px/1 "Archivo V",Archivo,system-ui,sans-serif;letter-spacing:.12em;',
    'text-transform:uppercase;color:rgba(240,238,234,.75);cursor:pointer;transition:border-color .2s,color .2s}',
    '.ebm-spin-chips button:hover,.ebm-spin-chips button.on{border-color:#ff5b04;color:#ff7a33}',
    '.ebm-spin-note{margin-top:8px;font:400 11.5px/1.5 "Archivo V",Archivo,system-ui,sans-serif;color:rgba(240,238,234,.45)}'
  ].join('');

  function injectCSS() {
    if (document.getElementById('ebm-spin-css')) return;
    var s = el('style'); s.id = 'ebm-spin-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  function mount(root) {
    if (root.__ebmSpin) return;
    root.__ebmSpin = true;
    injectCSS();
    var base = root.getAttribute('data-base') || 'assets/img/duster/spin360';
    fetch(base + '/manifest.json').then(function (r) { return r.json(); }).then(function (man) {
      build(root, base, man);
    }).catch(function (e) {
      root.innerHTML = '<p style="color:#888;font-size:12px">spin indisponible (' + e + ')</p>';
    });
  }

  function build(root, base, man) {
    var mobile = (root.clientWidth || innerWidth) < MOBILE_W;
    var dir = base + (mobile ? '/mobile/' : '/');
    var stage = el('div', 'ebm-spin', root);
    stage.setAttribute('role', 'slider');
    stage.setAttribute('aria-label', 'Tour du véhicule — ' + (man.vehicule || '') +
      ' — ' + man.frames.length + ' vues réelles, glisser pour tourner');
    stage.setAttribute('tabindex', '0');
    stage.setAttribute('aria-valuemin', '0');
    stage.setAttribute('aria-valuemax', String(man.frames.length - 1));

    var imgs = man.frames.map(function (f, i) {
      var im = el('img', 'f' + (i === 0 ? ' on' : ''), stage);
      im.src = dir + f.file;
      im.alt = (man.vehicule || 'véhicule') + ' — vue ' + f.label + ' (photo réelle)';
      im.draggable = false;
      return im;
    });
    var detailImgs = (man.details || []).map(function (f) {
      var im = el('img', 'f', stage);
      im.loading = 'lazy'; im.src = dir + f.file; im.alt = f.label; im.draggable = false;
      return im;
    });

    var hud = el('div', 'hud', stage);
    el('span', 'dot', hud);
    var lab = el('span', '', hud);
    var dots = el('div', 'dots', stage);
    var dotEls = man.frames.map(function () { return el('i', '', dots); });
    var hint = el('div', 'hint', stage);
    el('span', '', hint).textContent = '◀ faites glisser ▶';

    var cur = 0, inDetail = -1;
    function show(i) {
      inDetail = -1;
      cur = ((i % imgs.length) + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('on', k === cur); });
      detailImgs.forEach(function (im) { im.classList.remove('on'); });
      dotEls.forEach(function (d, k) { d.classList.toggle('on', k === cur); });
      lab.textContent = man.frames[cur].label;
      stage.setAttribute('aria-valuenow', String(cur));
      stage.setAttribute('aria-valuetext', man.frames[cur].label);
      chips.forEach(function (c) { c.classList.remove('on'); });
    }
    function showDetail(j) {
      inDetail = j;
      imgs.forEach(function (im) { im.classList.remove('on'); });
      detailImgs.forEach(function (im, k) { im.classList.toggle('on', k === j); });
      lab.textContent = man.details[j].label;
      chips.forEach(function (c, k) { c.classList.toggle('on', k === j); });
    }

    // chips vues détail + note d'honnêteté
    var chipBar = el('div', 'ebm-spin-chips', root);
    var chips = (man.details || []).map(function (f, j) {
      var b = el('button', '', chipBar);
      b.type = 'button'; b.textContent = f.label;
      b.addEventListener('click', function () { inDetail === j ? show(cur) : showDetail(j); });
      return b;
    });
    el('div', 'ebm-spin-note', root).textContent =
      man.frames.length + ' vues réelles du véhicule — fond harmonisé, la voiture n’est jamais retouchée. ' +
      'Le vrai tour complet en 3D arrive avec la capture atelier.';

    // drag
    var down = null, acc = 0, moved = false;
    var STEP = function () { return Math.max(48, stage.clientWidth / 9); };
    function interact() { hint.classList.add('off'); }
    stage.addEventListener('pointerdown', function (e) {
      down = e.clientX; acc = 0; moved = false;
      stage.classList.add('dragging');
      try { stage.setPointerCapture(e.pointerId); } catch (err) { /* pointeur synthétique */ }
    });
    stage.addEventListener('pointermove', function (e) {
      if (down === null) return;
      acc += e.clientX - down; down = e.clientX;
      var st = STEP();
      while (acc > st) { show(cur - 1); acc -= st; moved = true; interact(); }
      while (acc < -st) { show(cur + 1); acc += st; moved = true; interact(); }
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      stage.addEventListener(ev, function () {
        down = null; stage.classList.remove('dragging');
        if (!moved && inDetail >= 0) show(cur); // tap : sortir du détail
      });
    });
    stage.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { show(cur - 1); interact(); e.preventDefault(); }
      if (e.key === 'ArrowRight') { show(cur + 1); interact(); e.preventDefault(); }
    });
    setTimeout(interact, 6000);
    show(0);
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.hasAttribute && node.hasAttribute('data-spin360')) mount(node);
    if (node.querySelectorAll) {
      node.querySelectorAll('[data-spin360]').forEach(mount);
    }
  }

  function boot() {
    scan(document.documentElement);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) { m.addedNodes.forEach(scan); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
